import { RichTextInput } from "ra-input-rich-text";
import {
  Create,
  DateInput,
  DateTimeInput,
  Edit,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";

export function ContestEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="name" validate={required()} />
        <RichTextInput source="description" />
        <DateTimeInput source="startDate" validate={required()} />
        <DateTimeInput source="endDate" validate={required()} />
        <SelectInput
          source="type"
          choices={[
            { id: "online", name: "Online" },
            { id: "offline", name: "Offline" },
          ]}
          validate={required()}
          defaultValue={"online"}
        />
        <TextInput source="location" />
        <TextInput source="googleMapsLink" />
        <TextInput source="googleFormLink" />
        <TextInput source="organizerName" />
        <TextInput source="organizerEmail" type="email" />
        <NumberInput source="organizerPhone" />
        <FileInput
          source="images"
          title="Uploaded Files"
          route="contest/upload"
          edit
          add
        />

        <RichTextInput source="rules" />
        <RichTextInput source="prizes" />
        <RichTextInput source="terms" />
      </SimpleForm>
    </Edit>
  );
}
